/* jshint esversion: 6 */
/* jshint ignore:start */
import { useState, useEffect, useContext } from 'react';
import { MyContext } from '../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
import { showToast } from '../showTost';

export const ImgLoad = ({ url, customestyle }) => {
    const [imgLoaded, setImgLoaded] = useState(false);
    return (<>
        <img
            src={url}
            alt="Model"
            loading="lazy"
            onLoad={() => setImgLoaded(true)}
            onError={() => setImgLoaded(true)}
            className={`${customestyle} transition-opacity duration-300 ${imgLoaded ? "opacity-100" : "opacity-0"}`}
        />
    </>
    )
}

const SelectCar = ({ setShowSelectCarPage, setShowStoreList }) => {

    const { t } = useTranslation();

    const { ApiBasUrl, ImgBasUrl, setSelectModel, setGuestMoodeData, setIsGuestMood } = useContext(MyContext);
    const [isshow, setIsShow] = useState(1);

    const [vehiclelist, setVehicleList] = useState([]);
    const [brandlist, setBrandList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectcategoryid, setSelectCategoryId] = useState("");
    const [selectbrandtitle, setSelectBrandTitle] = useState("");
    const [modellist, setModelList] = useState([]);

    useEffect(() => {
        axios.post(`${ApiBasUrl}/vehicle_category.php`)
            .then((res) => {
                setVehicleList(res.data.vehiclecatlist);
            })
            .catch((error) => {
                console.error("vehicle_category.php", error);
            });
    }, []);

    const HandleSelectVehicle = (id) => {
        setSelectCategoryId(id);
        setLoading(true);
        setIsShow(2);

        axios.post(`${ApiBasUrl}/brand_list.php`, { cat_id: id })
            .then((res) => {
                setBrandList(res.data.Brandlist);
                setLoading(false);
            })
            .catch((error) => {
                console.error("brand_list.php", error);
            });
    }

    const HandleSelectBrand = async (item) => {
        setSelectBrandTitle(item);
        setLoading(true);
        setIsShow(3);

        axios.post(`${ApiBasUrl}/model_list.php`, { cat_id: selectcategoryid, brand_id: item.brand_id })
            .then((res) => {
                setModelList(res.data.ModelList);
                setLoading(false);
            })
            .catch((error) => {
                console.error("model_list.php", error);
            });
    }

    const HandleSelectModel = (item) => {

        const Data = {
            index: 0,
            cat_id: selectcategoryid,
            brand_id: selectbrandtitle?.brand_id,
            ctitle: item.ctitle,
            model_img: item.img,
            model_id: item.model_id,
            name: `${selectbrandtitle?.title} ${item.ctitle}`
        };

        const Userid = secureLocalStorage.getItem("Userid");

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const lat = position.coords.latitude;
                    const long = position.coords.longitude;
                    axios.post(`${ApiBasUrl}/store_list.php`, { cat_id: Data?.cat_id, lats: lat, longs: long })
                        .then((res) => {
                            if (res.data.store_list.length <= 0) {
                                showToast({ title: "This vehicle does not have a service center in this area.", id: "info" });
                            } else {
                                if (!Userid) {
                                    setIsGuestMood(true);
                                    setGuestMoodeData(Data);
                                    secureLocalStorage.setItem("Guest", true);
                                    setShowStoreList(true);
                                    setShowSelectCarPage(false);
                                } else {
                                    setSelectModel(Data);
                                }
                            }
                        })
                        .catch((error) => {
                            console.error("store_list.php", error);
                        })
                })
        }


    }

    const HandleCloseMode = () => {
        setShowSelectCarPage(false);
    }

    return (
        <div onClick={HandleCloseMode}>

            {isshow === 1 && <div onClick={(e) => e.stopPropagation()} className="select_vehicle mx-auto relative">
                <button onClick={() => setShowSelectCarPage(false)} className='bg-white p-[2px] rounded-full absolute -right-[8px] -top-[8px]'>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                    </svg>
                </button>
                <div className="py-[10px] px-[15px]">
                    <h1 className="font-bold text-[20px] text-center">{t("Select Your Vehicle")}</h1>
                    <div className=" flex flex-wrap items-center max-_430_:justify-center max-_430_:gap-[20px] gap-[10px] overflow-hidden">
                        {vehiclelist.length >= 1
                            ? vehiclelist.map((item, index) => {
                                return <div onClick={() => HandleSelectVehicle(item.cat_id)} key={index} className="w-[calc(50%-10px)] max-_430_:w-[70%]">
                                    <ImgLoad url={ImgBasUrl + item.img} customestyle="w-[100%] h-[100%] cursor-pointer" />
                                </div>
                            })
                            : <div className="w-[100%] h-[200px] flex items-center justify-center">
                                <div className="loader2"></div>
                            </div>}
                    </div>
                </div>
            </div>}

            {isshow === 2 && <div onClick={(e) => e.stopPropagation()} className="select_model mx-auto relative">
                <button onClick={() => setShowSelectCarPage(false)} className='bg-white p-[2px] rounded-full absolute -right-[8px] -top-[8px]'>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                    </svg>
                </button>
                <div className="py-[10px] px-[15px]">
                    <div className="flex items-center gap-[10px]">
                        <svg onClick={() => setIsShow(1)} className="cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                        </svg>
                        <h1 className="font-[500] text-[20px] max-_430_:text-[16px]">{t("Select Your Vehicle Brand")}</h1>
                    </div>
                    {loading
                        ? <div className="w-[100%] h-[450px] flex items-center justify-center">
                            <div className="loader2"></div>
                        </div>
                        : (brandlist.length >= 1
                            ? <div className="max-h-[450px] scroll-container list_box">
                                {brandlist.map((item, index) => {
                                    return (
                                        <div onClick={() => HandleSelectBrand(item)} key={index} className="brand_img border-[1px] rounded-[10px]">
                                            <ImgLoad url={ImgBasUrl + item.img} customestyle="w-[100%] h-[100%] cursor-pointer" />
                                        </div>
                                    );
                                })}
                            </div>
                            : <div className="w-[100%] h-[450px] flex items-center justify-center">
                                <h1 className="font-[500] text-[18px] text-center">{t("No brand found for")} <br /> {t("this category")}</h1>
                            </div>
                        )
                    }
                </div>
            </div>
            }

            {isshow === 3 && <div onClick={(e) => e.stopPropagation()} className="select_model mx-auto relative">
                <button onClick={() => setShowSelectCarPage(false)} className='bg-white p-[2px] rounded-full absolute -right-[8px] -top-[8px]'>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18.53 17.47C18.823 17.763 18.823 18.238 18.53 18.531C18.384 18.677 18.192 18.751 18 18.751C17.808 18.751 17.616 18.678 17.47 18.531L12 13.061L6.52999 18.531C6.38399 18.677 6.19199 18.751 5.99999 18.751C5.80799 18.751 5.61599 18.678 5.46999 18.531C5.17699 18.238 5.17699 17.763 5.46999 17.47L10.94 12L5.46999 6.53005C5.17699 6.23705 5.17699 5.76202 5.46999 5.46902C5.76299 5.17602 6.238 5.17602 6.531 5.46902L12.001 10.939L17.471 5.46902C17.764 5.17602 18.239 5.17602 18.532 5.46902C18.825 5.76202 18.825 6.23705 18.532 6.53005L13.062 12L18.53 17.47Z" fill="#25314C" />
                    </svg>
                </button>
                <div className="py-[10px] px-[15px]">
                    <div className="flex items-center gap-[10px]">
                        <svg onClick={() => setIsShow(2)} className="cursor-pointer" width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M21.7501 12C21.7501 12.414 21.4141 12.75 21.0001 12.75H4.81115L10.5311 18.47C10.8241 18.763 10.8241 19.238 10.5311 19.531C10.3851 19.677 10.1931 19.751 10.0011 19.751C9.80909 19.751 9.61706 19.678 9.47106 19.531L2.47106 12.531C2.40206 12.462 2.3472 12.3791 2.3092 12.2871C2.2332 12.1041 2.2332 11.8971 2.3092 11.7141C2.3472 11.6221 2.40206 11.539 2.47106 11.47L9.47106 4.46999C9.76406 4.17699 10.2391 4.17699 10.5321 4.46999C10.8251 4.76299 10.8251 5.23803 10.5321 5.53103L4.81213 11.251H21.0001C21.4141 11.25 21.7501 11.586 21.7501 12Z" fill="#25314C" />
                        </svg>
                        <h1 className="font-[500] text-[20px] max-_430_:text-[16px]">{t("Select Your")} {selectbrandtitle.title} {t("Model")}</h1>
                    </div>
                    {loading
                        ? <div className="w-full h-[450px] flex items-center justify-center">
                            <div className="loader2"></div>
                        </div>
                        : <div className="max-h-[450px] scroll-container list_box">
                            {modellist.length >= 1
                                ? modellist.map((item, index) => {
                                    return <div key={index} onClick={() => HandleSelectModel(item)} className="model_box">
                                        <ImgLoad url={ImgBasUrl + item.img} customestyle="w-full h-[100px] object-contain" />
                                        <span className="font-[500] text-[14px]">{item.ctitle}</span>
                                    </div>
                                })
                                : <div className="w-[100%] h-[200px] flex items-center justify-center">
                                    <h1 className="font-[500] text-[18px] text-center">{t("No model found for")} <br /> {t("this brand")}</h1>
                                </div>}
                        </div>
                    }
                </div>
            </div>}

        </div >
    )
}

export default SelectCar;
/* jshint ignore:end */